var map = {
	"./background-image.svg": 77043,
	"./background-logo-laptop.svg": 62926,
	"./background-logo.svg": 51393,
	"./course/complete-course.svg": 9172,
	"./education/exit-test.svg": 5991,
	"./education/ite.svg": 83394,
	"./education/junior-collage.svg": 99077,
	"./education/not-enjoy-degree.svg": 42568,
	"./education/not-enjoy-level.svg": 28090,
	"./education/not-pass-test.svg": 2698,
	"./education/pass-test.svg": 93390,
	"./education/polytechnic.svg": 24358,
	"./education/primary.svg": 49836,
	"./education/second.svg": 21186,
	"./education/university.svg": 46078,
	"./game-review.svg": 558,
	"./life-card/agree-card.svg": 28480,
	"./life-card/disagree-card.svg": 97966,
	"./life-card/start-life-card.svg": 29607,
	"./live-expenses.svg": 85241,
	"./logo.png": 82806,
	"./onboarding/energy.svg": 15459,
	"./onboarding/onboarding_1.svg": 7640,
	"./onboarding/onboarding_3.svg": 43770,
	"./onboarding/onboarding_4.svg": 4869,
	"./onboarding/onboarding_5.svg": 53700,
	"./onboarding/onboarding_6.svg": 96823,
	"./onboarding/onboarding_self-paced.svg": 17289,
	"./possessions/car-1.svg": 6553,
	"./possessions/car-2.svg": 15178,
	"./possessions/car-3.svg": 75547,
	"./possessions/car-us-1.svg": 70994,
	"./possessions/car-us-2.svg": 76033,
	"./possessions/car-us-3.svg": 84912,
	"./possessions/car.svg": 32879,
	"./possessions/home-1.svg": 47876,
	"./possessions/home-2.svg": 52471,
	"./possessions/home-3.svg": 6022,
	"./possessions/home-us-1.svg": 64845,
	"./possessions/home-us-2.svg": 16494,
	"./possessions/home-us-3.svg": 44927,
	"./possessions/home.svg": 69758,
	"./possessions/money 1.svg": 84680,
	"./possessions/money 2.svg": 35419,
	"./possessions/money 3.svg": 75050,
	"./possessions/phone-level-1.svg": 71166,
	"./possessions/phone-level-2.svg": 25341,
	"./possessions/phone-level-3.svg": 35868,
	"./possessions/phone.svg": 64057,
	"./possessions/travel-level-1.svg": 80088,
	"./possessions/travel-level-2.svg": 30827,
	"./possessions/travel-level-3.svg": 99866,
	"./possessions/travel.svg": 58239,
	"./reward-achievements/green.svg": 40691,
	"./reward-achievements/grey.svg": 58131,
	"./rewards-modal/modal-background.svg": 11552,
	"./rewards/grey-badge.svg": 10947,
	"./rewards/main-body/career/bronze.svg": 34872,
	"./rewards/main-body/career/gold.svg": 40434,
	"./rewards/main-body/career/silver.svg": 42075,
	"./rewards/main-body/education/bronze.svg": 80770,
	"./rewards/main-body/education/gold.svg": 91880,
	"./rewards/main-body/education/pink.svg": 29338,
	"./rewards/main-body/education/silver.svg": 74397,
	"./rewards/main-body/happiness/bronze.svg": 94133,
	"./rewards/main-body/happiness/gold.svg": 96575,
	"./rewards/main-body/happiness/pink.svg": 95405,
	"./rewards/main-body/happiness/silver.svg": 46474,
	"./rewards/main-body/money/bronze.svg": 51900,
	"./rewards/main-body/money/gold.svg": 62606,
	"./rewards/main-body/money/pink.svg": 61632,
	"./rewards/main-body/money/silver.svg": 63887,
	"./rewards/main-body/skills/bronze.svg": 36180,
	"./rewards/main-body/skills/gold.svg": 61174,
	"./rewards/main-body/skills/silver.svg": 28311,
	"./rewards/rewards-sectors/avid-traveller.svg": 31729,
	"./rewards/rewards-sectors/career.svg": 75931,
	"./rewards/rewards-sectors/driver.svg": 60223,
	"./rewards/rewards-sectors/education.svg": 901,
	"./rewards/rewards-sectors/happiness.svg": 97440,
	"./rewards/rewards-sectors/job-hopper.svg": 84409,
	"./rewards/rewards-sectors/loyal-employee.svg": 66761,
	"./rewards/rewards-sectors/master.svg": 64399,
	"./rewards/rewards-sectors/mid-career-change.svg": 78425,
	"./rewards/rewards-sectors/money.svg": 4015,
	"./rewards/rewards-sectors/security.svg": 43891,
	"./rewards/rewards-sectors/skills.svg": 34735,
	"./rewards/rewards-sectors/stylish.svg": 29093,
	"./rewards/rewards-sectors/well-connected.svg": 99751,
	"./rewards/rewards-sectors/world-traveller.svg": 6045,
	"./rewards/ribbons/large/sloping/blue.svg": 55553,
	"./rewards/ribbons/large/sloping/dark-blue.svg": 45450,
	"./rewards/ribbons/large/sloping/green.svg": 19098,
	"./rewards/ribbons/large/sloping/orange.svg": 95495,
	"./rewards/ribbons/large/sloping/violet.svg": 30196,
	"./rewards/ribbons/large/straight/blue.svg": 14783,
	"./rewards/ribbons/large/straight/dark-blue.svg": 844,
	"./rewards/ribbons/large/straight/green.svg": 81348,
	"./rewards/ribbons/large/straight/orange.svg": 35921,
	"./rewards/ribbons/large/straight/violet.svg": 50886,
	"./rewards/ribbons/small/sloping/blue.svg": 68245,
	"./rewards/ribbons/small/sloping/dark-blue.svg": 7126,
	"./rewards/ribbons/small/sloping/green.svg": 50382,
	"./rewards/ribbons/small/sloping/orange.svg": 883,
	"./rewards/ribbons/small/sloping/violet.svg": 62984,
	"./rewards/ribbons/small/straight/blue.svg": 17411,
	"./rewards/ribbons/small/straight/dark-blue.svg": 57096,
	"./rewards/ribbons/small/straight/green.svg": 84840,
	"./rewards/ribbons/small/straight/orange.svg": 99277,
	"./rewards/ribbons/small/straight/violet.svg": 634,
	"./waiting/man-waiting.svg": 62211,
	"./waiting/woman-waiting.svg": 21873,
	"./work/complete-work.svg": 39828,
	"./work/cycles-exceed.svg": 91023,
	"./work/get-new-work.svg": 68242,
	"./work/not-complete-work.svg": 80228,
	"./work/quit-work.svg": 34248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;